<script setup>
import { computed, toRef } from 'vue';
import { useChannelIcon } from './provider';
import Icon from 'next/icon/Icon.vue';

defineOptions({ inheritAttrs: false });

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

/** Same public asset as inbox settings list/new channel; bind :src avoids Vite resolving `/assets/...` as a module. */
const IUNGO_CHANNEL_IMAGE = '/public/integrations/channels/badges/iungo.png';

const channelIcon = useChannelIcon(toRef(props, 'inbox'));

const isIungoChannel = computed(
  () => props.inbox?.channel_type === 'Channel::Iungo'
);
</script>

<template>
  <img
    v-if="isIungoChannel"
    :src="IUNGO_CHANNEL_IMAGE"
    alt=""
    role="presentation"
    class="object-contain"
    v-bind="$attrs"
  />
  <Icon v-else :icon="channelIcon" v-bind="$attrs" />
</template>
